import {Language} from '../umpire-language-service';

export interface UmpireTag {
  id: string;

  name: string | null;

  type: string;

  locale: Language;

  available_translations: Language[];

  client_id?: string;

  slug?: string;
}
